import type { SyncAdapter } from './sync-adapter.js';

/** Default adapter present in the MVP. Does nothing — sync stays off. */
export const nullAdapter: SyncAdapter = {
  meta: {
    id: 'none',
    name: 'No sync',
    description: 'All data stays on this device. Use export/import for manual portability.',
    requiresNetwork: false,
  },
  async isAvailable() { return true; },
  async isConnected() { return false; },
  async connect() { /* no-op */ },
  async disconnect() { /* no-op */ },
  async list() { return []; },
  async upload() { throw new Error('Sync is disabled.'); },
  async download() { throw new Error('Sync is disabled.'); },
  async remove() { throw new Error('Sync is disabled.'); },
};
